import { render, staticRenderFns } from "./SettingBlockedCountries.vue?vue&type=template&id=4df153cc&"
import script from "./SettingBlockedCountries.vue?vue&type=script&lang=js&"
export * from "./SettingBlockedCountries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports